import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getUserPermission } from "../lib";
import {
  getAccessDeniedRedirectPath,
  getPermissionDisplayName,
  getRequiredPermissionForRoute,
  userCanAccessRoute,
} from "../lib/appPermissions";
import { ensureUserProfileLoaded } from "./postLoginSetup";
import { showToast } from "../service/toastService";

export function RequireTabAccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function validateAccess() {
      setIsAllowed(false);

      try {
        await ensureUserProfileLoaded();
      } catch {
        // Safe fallback scopes are applied inside ensureUserProfileLoaded.
      }

      if (cancelled) {
        return;
      }

      const userScopes = getUserPermission();
      const requiredPermission = getRequiredPermissionForRoute(
        location.pathname,
        location.search
      );

      if (!userCanAccessRoute(userScopes, requiredPermission)) {
        const tabName = getPermissionDisplayName(requiredPermission);
        showToast(`Access denied to "${tabName}"`, "error");
        navigate(getAccessDeniedRedirectPath(userScopes), { replace: true });
        return;
      }

      setIsAllowed(true);
    }

    validateAccess();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search, navigate]);

  if (!isAllowed) {
    return (
      <div className="app">
        <div className="loader-container" style={{ padding: "4rem", textAlign: "center" }}>
          <i className="fa fa-spinner fa-spin" style={{ fontSize: "2rem" }} />
        </div>
      </div>
    );
  }

  return <Outlet />;
}
